import { combineEpics } from 'redux-observable';

import { fetchAccountTypesEpic } from './account-types/epics';
import { fetchActionTilesEpic } from './action-tiles/epics';
import { fetchRetirementIncome, fetchSavingsBalance, postSimulation } from './charts/epics';
import { fetchPlans, fetchParticipantProfile, fetchRixCompensation } from './participant-profile/epics';
import {
  fetchEducationVideosEpic,
  fetchFinancialWellnessTilesEpic,
  fetchNavigationOptionsEpic,
  fetchTilesInformationEpic,
  fetchDistroTilesInformationEpic,
} from './education-container/epics';
import { fetchRIScenario, updateRIScenario } from './ri-scenario/epics';
import { fetchSalary } from './salary/epics';
import { deleteSpouse } from './spouse/epics';
import { fetchYodleeConsent, refreshYodlee } from './yodlee-consent/epics';
import { fetchIncomeEventsEpic } from './income-events/epics';
import { fetchExpenseEventsEpic } from './expense-events/epics';

export default combineEpics(
  fetchAccountTypesEpic,
  fetchActionTilesEpic,
  fetchEducationVideosEpic,
  fetchFinancialWellnessTilesEpic,
  fetchNavigationOptionsEpic,
  fetchPlans,
  fetchParticipantProfile,
  fetchRixCompensation,
  fetchRetirementIncome,
  fetchRIScenario,
  fetchSavingsBalance,
  fetchSalary,
  postSimulation,
  updateRIScenario,
  deleteSpouse,
  fetchYodleeConsent,
  refreshYodlee,
  fetchTilesInformationEpic,
  fetchIncomeEventsEpic,
  fetchExpenseEventsEpic,
  fetchDistroTilesInformationEpic
);
